import { CustomVoice } from "@davi-ai/retorik-framework";

export const VOICE_CHANGE = "VOICE_CHANGE";

export default function voiceChangeAction(voice: CustomVoice) {
  return {
    type: VOICE_CHANGE,
    payload: {
      ...voice,
    },
  };
}
